import React from 'react';
import { FacebookIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark pt-20 pb-10 border-t border-white/10" data-id="element-121">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-122">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-123">
          {/* Brand */}
          <div className="md:col-span-2" data-id="element-124">
            <a href="#" className="flex items-center gap-4 mb-4" data-id="element-125">
              <img src="https://cdn.magicpatterns.com/uploads/omg18aCKk2JTiX5RPDGMer/apm-logo-1.png" alt="Apostle Phillips Ministries" className="h-16 w-auto" data-id="element-126" />
              <div data-id="element-127">
                <span className="text-gold font-playfair font-bold text-2xl tracking-wider uppercase block" data-id="element-128">
                  Apostle Phillips
                </span>
                <span className="block text-xs tracking-[0.3em] text-white/70 font-inter font-normal mt-1" data-id="element-129">
                  Ministries
                </span>
              </div>
            </a>
            <p className="text-gray-400 font-inter max-w-sm mt-6 leading-relaxed" data-id="element-130">
              A Christian organization geared to revive and restore the love of
              God in the heart of men.
            </p>
            <div className="flex items-center gap-4 mt-8" data-id="element-131">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-gold hover:text-dark transition-colors" data-id="element-132">
                <FacebookIcon className="w-5 h-5" data-id="element-133" />
              </a>
            </div>

            {/* Newsletter */}
            <div className="mt-10" data-id="element-134">
              <h4 className="text-white font-semibold text-sm tracking-wider uppercase mb-4" data-id="element-135">
                Newsletter
              </h4>
              <p className="text-gray-400 font-inter text-sm mb-4" data-id="element-136">
                Subscribe to receive latest news and updates on APM.
              </p>
              <div className="flex gap-2" data-id="element-137">
                <input type="email" placeholder="Your email" className="flex-1 px-4 py-2.5 bg-white/5 border border-white/10 text-white placeholder:text-gray-500 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors rounded-sm text-sm" data-id="element-138" />
                <button className="px-5 py-2.5 bg-gold hover:bg-goldLight text-dark font-semibold text-sm tracking-wide transition-colors rounded-sm shrink-0" data-id="element-139">
                  Subscribe
                </button>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-140">
            <h4 className="text-white font-semibold tracking-wider uppercase mb-6" data-id="element-141">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-142">
              <li data-id="element-143">
                <a href="#about" className="text-gray-400 hover:text-gold transition-colors" data-id="element-144">
                  About
                </a>
              </li>
              <li data-id="element-145">
                <a href="#ministry" className="text-gray-400 hover:text-gold transition-colors" data-id="element-146">
                  Mission & Vision
                </a>
              </li>
              <li data-id="element-147">
                <a href="#messages" className="text-gray-400 hover:text-gold transition-colors" data-id="element-148">
                  Messages
                </a>
              </li>
              <li data-id="element-149">
                <a href="#events" className="text-gray-400 hover:text-gold transition-colors" data-id="element-150">
                  Events
                </a>
              </li>
              <li data-id="element-151">
                <a href="#books" className="text-gray-400 hover:text-gold transition-colors" data-id="element-152">
                  Books
                </a>
              </li>
              <li data-id="element-153">
                <a href="#contact" className="text-gray-400 hover:text-gold transition-colors" data-id="element-154">
                  Prayer Request
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-155">
            <h4 className="text-white font-semibold tracking-wider uppercase mb-6" data-id="element-156">
              Contact
            </h4>
            <ul className="space-y-4 text-gray-400" data-id="element-157">
              <li className="flex items-start gap-3" data-id="element-158">
                <MapPinIcon className="w-4 h-4 text-gold mt-1 shrink-0" data-id="element-159" />
                <span data-id="element-160">
                  3950, 48th Street,
                  <br data-id="element-161" />
                  Bladensburg MD. 20710
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-162">
                <MailIcon className="w-4 h-4 text-gold shrink-0" data-id="element-163" />
                <a href="mailto:info@apostlephillipsministries.org" className="hover:text-gold transition-colors" data-id="element-164">
                  info@apostlephillipsministries.org
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-165">
                <PhoneIcon className="w-4 h-4 text-gold shrink-0" data-id="element-166" />
                <a href="tel:+12403939773" className="hover:text-gold transition-colors" data-id="element-167">
                  (240) 393-9773
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500" data-id="element-168">
          <p data-id="element-169">
            © {new Date().getFullYear()} Apostle Phillips Ministries. All
            rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-170">
            <a href="#" className="hover:text-white transition-colors" data-id="element-171">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-172">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}